export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20digital%20entertainment%20hub%20concept%2C%20abstract%20representation%20of%20connected%20video%20platforms%20as%20glowing%20nodes%20in%20a%20network%2C%20orange%20and%20amber%20color%20scheme%2C%20modern%20tech%20aesthetic%2C%20clean%20and%20minimal%20design%2C%20soft%20glowing%20connections%20between%20content%20hubs&width=960&height=720&seq=about-visual-2026&orientation=landscape"
                alt="桔子视频平台介绍"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-5">
              关于桔子视频
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                桔子视频是一个专注于聚合全网热门视频平台内容的导航站点。
                我们收录了红桃视频、樱桃视频、茄子视频、糖心视频等多个广受欢迎的在线视频平台，
                为广大用户提供一站式的视频浏览体验。
              </p>
              <p>
                不同于单一视频站点，桔子视频整合了多个平台的优质资源，
                涵盖高清电视剧、热门短剧、综艺娱乐、影视大片等丰富内容类型。
                用户无需在多个平台之间来回切换，即可轻松浏览各大平台的最新内容。
              </p>
              <p>
                我们坚持每日同步更新，确保收录的每一部作品都能第一时间呈现给用户。
                同时采用先进的播放技术优化，保障流畅不缓冲的观看体验，
                让精彩内容触手可及。桔子视频——你的全网视频导航专家。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-extrabold text-primary-500">20万+</div>
                <div className="text-xs text-foreground-600 mt-1">收录作品</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-extrabold text-accent-500">99+</div>
                <div className="text-xs text-foreground-600 mt-1">合作平台</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-extrabold text-secondary-500">24h</div>
                <div className="text-xs text-foreground-600 mt-1">更新频率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}